export default __webpack_public_path__ + "static/media/loading.9cfcf754.gif";